import { render, staticRenderFns } from "./PermissionOrganisation.vue?vue&type=template&id=51d0390f&"
import script from "./PermissionOrganisation.vue?vue&type=script&lang=ts&"
export * from "./PermissionOrganisation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports